<template>
  <div class="greeting-sign-in">
    <a :href="dashboardLink" itemprop="url">
      <em class="icon-signin-white person-icon"></em>
      <span class="greeting-text">
        {{ label }}
      </span>
    </a>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "greeting-sign-in",
  props: {
    dashboardLink: {
      type: String,
    },
    defaultText: {
      type: String,
    },
    greetingText: {
      type: String,
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["isAuthenticated", "haveProfileData"]),
    label() {
      var label = "";
      if (this.user?.title) {
        var addDot = this.user?.title.endsWith(".");
        if (!addDot) {
          label = this.user?.title + ". " + this.user?.lastName;
        } else {
          label = this.user?.title + " " + this.user?.lastName;
        }
      } else {
        label = this.user?.lastName;
      }
      return this.isAuthenticated && this.haveProfileData
        ? this.greetingText.replace("{{firstname}}", label || "")
        : this.defaultText;
    },
  },
  async mounted() {
    this.$root.$emit("greeting-sign-in-mounted");
    if (this.isAuthenticated && !this.haveProfileData) {
      await this.getProfile();
    }
  },
  methods: {
    ...mapActions("auth", ["getProfile"]),
  },
};
</script>
